var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { singleton } from '@keenondrums/singleton';
import { Basket, BasketConfig, BasketData, BasketDataTransformer, BasketSettings, BasketStorage, Config, CwpSetup, EsgApi, EsgTransformer, FeatureFlags, ShadowSetup, } from './services';
let BasketProxy = class BasketProxy {
    constructor(environment = {}) {
        var _a;
        const { contentService, assetPathResolver, hrefResolver, siteContextResolverService, windowTransformer, } = new CwpSetup(environment).getServiceInstances();
        this.featureFlags = new FeatureFlags(contentService);
        const config = new Config(assetPathResolver);
        this.basketConfig = new BasketConfig(config);
        this.basketConfig.setLocalBasketConfig((_a = environment === null || environment === void 0 ? void 0 : environment.localConfiguration) === null || _a === void 0 ? void 0 : _a.siteContext);
        const prodConfig = JSON.parse(contentService.get('Basket_Config_JSON', JSON.stringify(this.basketConfig.localBasketConfig)));
        this.basketConfig.setConfigData(prodConfig);
        const basketData = new BasketData(hrefResolver, contentService);
        this.basketDataTransformer = new BasketDataTransformer(hrefResolver, contentService, this.basketConfig);
        this.basketSettings = new BasketSettings();
        this.basketStorage = new BasketStorage(window, this.basketSettings, siteContextResolverService);
        siteContextResolverService.setContext(windowTransformer.getContext(window, environment));
        const { shadowStorage } = ShadowSetup.init(siteContextResolverService, hrefResolver, contentService, this.basketDataTransformer);
        const esgApi = new EsgApi(hrefResolver);
        this.esgTransformer = new EsgTransformer(esgApi, basketData, this.basketDataTransformer, this.featureFlags);
        this.basket = new Basket(this.basketSettings, this.basketStorage, basketData, this.basketDataTransformer, this.esgTransformer, shadowStorage);
    }
    exposedMethods() {
        const { addFundToBasket, containsFund, isBasketFullWithActivatedOnly, onBasketChange, basketChangeUnSubscribe, removeFromBasket, onBasketNotificationChange, basketNotificationUnsubscribe, onFundAdded, fundAddedUnSubscribe, onFundRemoved, fundRemovedUnSubscribe, getBasket, getBasketWithoutAlternatives, getBasketCount, getBasketCapacity, getBasketItemById, removeAllFromBasket, makePrimary, updateCampaignId, activateAllAlternativeFund, addToBasketOrdered, toggleActivationForAlternatives, onIsLoading, onIsLoadingUnSubscribe, isBasketEmpty, updateBasket, getCampaignId, addToBasket, addFundsToBasket, getBasketFundsTickerArray, handleAlternativesWrapper, isBasketFull, getBasketCountWithActivatedFunds, getRemovableAlternatives, hasInactivatedAlternatives, getBasketFundsAsString, getBasketFundTicker, getBasketIds, getActivatedBasketIds, getBasketFundsAsIdString, getConcatenatedTicketAndId, } = this.basket;
        const { onErrorHandler, errorHandlerUnSubscribe } = this.basketDataTransformer;
        const { isEnabled } = this.featureFlags;
        const { onAlternativeChange, alternativeChangeUnSubscribe } = this.esgTransformer;
        const { getFundCardConfig, setConfigData, fetchConfigData } = this.basketConfig;
        const { readAlternativeStates } = this.basketStorage;
        const { getSetting } = this.basketSettings;
        return {
            addFundToBasket: addFundToBasket.bind(this.basket),
            removeFromBasket: removeFromBasket.bind(this.basket),
            isBasketFull: isBasketFull.bind(this.basket),
            isBasketFullWithActivatedOnly: isBasketFullWithActivatedOnly.bind(this.basket),
            containsFund: containsFund.bind(this.basket),
            onBasketChange: onBasketChange.bind(this.basket),
            basketChangeUnSubscribe: basketChangeUnSubscribe.bind(this.basket),
            getBasket: getBasket.bind(this.basket),
            getBasketWithoutAlternatives: getBasketWithoutAlternatives.bind(this.basket),
            getBasketCount: getBasketCount.bind(this.basket),
            getBasketCapacity: getBasketCapacity.bind(this.basket),
            getBasketItemById: getBasketItemById.bind(this.basket),
            removeAllFromBasket: removeAllFromBasket.bind(this.basket),
            makePrimary: makePrimary.bind(this.basket),
            updateCampaignId: updateCampaignId.bind(this.basket),
            activateAllAlternativeFund: activateAllAlternativeFund.bind(this.basket),
            addToBasketOrdered: addToBasketOrdered.bind(this.basket),
            toggleActivationForAlternatives: toggleActivationForAlternatives.bind(this.basket),
            onIsLoading: onIsLoading.bind(this.basket),
            onIsLoadingUnSubscribe: onIsLoadingUnSubscribe.bind(this.basket),
            isBasketEmpty: isBasketEmpty.bind(this.basket),
            updateBasket: updateBasket.bind(this.basket),
            getCampaignId: getCampaignId.bind(this.basket),
            addToBasket: addToBasket.bind(this.basket),
            addFundsToBasket: addFundsToBasket.bind(this.basket),
            getBasketFundsTickerArray: getBasketFundsTickerArray.bind(this.basket),
            handleAlternativesWrapper: handleAlternativesWrapper.bind(this.basket),
            getBasketCountWithActivatedFunds: getBasketCountWithActivatedFunds.bind(this.basket),
            getRemovableAlternatives: getRemovableAlternatives.bind(this.basket),
            hasInactivatedAlternatives: hasInactivatedAlternatives.bind(this.basket),
            getBasketFundsAsString: getBasketFundsAsString.bind(this.basket),
            getBasketFundTicker: getBasketFundTicker.bind(this.basket),
            getBasketIds: getBasketIds.bind(this.basket),
            getActivatedBasketIds: getActivatedBasketIds.bind(this.basket),
            getBasketFundsAsIdString: getBasketFundsAsIdString.bind(this.basket),
            getConcatenatedTicketAndId: getConcatenatedTicketAndId.bind(this.basket),
            onErrorHandler: onErrorHandler.bind(this.basketDataTransformer),
            errorHandlerUnSubscribe: errorHandlerUnSubscribe.bind(this.basketDataTransformer),
            onBasketNotificationChange: onBasketNotificationChange.bind(this.basket),
            basketNotificationUnsubscribe: basketNotificationUnsubscribe.bind(this.basket),
            onFundAdded: onFundAdded.bind(this.basket),
            fundAddedUnSubscribe: fundAddedUnSubscribe.bind(this.basket),
            onFundRemoved: onFundRemoved.bind(this.basket),
            fundRemovedUnSubscribe: fundRemovedUnSubscribe.bind(this.basket),
            isEnabled: isEnabled.bind(this.featureFlags),
            onAlternativeChange: onAlternativeChange.bind(this.esgTransformer),
            alternativeChangeUnSubscribe: alternativeChangeUnSubscribe.bind(this.esgTransformer),
            getFundCardConfig: getFundCardConfig.bind(this.basketConfig),
            setConfigData: setConfigData.bind(this.basketConfig),
            fetchConfigData: fetchConfigData.bind(this.basketConfig),
            readAlternativeStates: readAlternativeStates.bind(this.basketStorage),
            getSetting: getSetting.bind(this.basketSettings),
        };
    }
};
BasketProxy = __decorate([
    singleton
], BasketProxy);
export { BasketProxy };
